import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import FilterIcon from '../assets/icons/JSX/FilterIcon'
import Responsive from '../assets/config/Responsive'

const ExportButton: React.FC<{
  onClick?: () => void
  text?: string
  style?: React.CSSProperties
}> = ({ onClick, text = 'ექსპორტი', style }) => {
  return (
    <ExportBtn style={style} type="button" onClick={onClick}>
      <span>{text}</span>
    </ExportBtn>
  )
}
//
//
// styles
const ExportBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Colors.primaryBlack};
  border-radius: 4px;
  background-color: transparent;
  height: 48px;
  min-width: 104px;
  transition: all 200ms ease-in-out;
  padding-left: 20px;
  padding-right: 20px;

  /* open filter button icon */
  svg {
    height: 9px;
    margin-left: 10px;
  }

  span {
    color: ${Colors.primaryBlack};
    -webkit-text-fill-color: rgba(0, 0, 0, 1);
    -webkit-opacity: 1;
  }

  /* hover styles */
  &:hover {
    transition: all 200ms ease-in-out;
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    ${Responsive.mobile} {
      border: 1px solid ${Colors.primaryBlack};
      background-color: transparent;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
    }
    ${Responsive.tablet} {
      border: 1px solid ${Colors.primaryBlack};
      background-color: transparent;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
    }
  }
  &:active {
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    opacity: 0.9;
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
  }
`

export default ExportButton
